import { Icon } from '@zillow/constellation-10';
import { IconExternalFilled } from '@zillow/constellation-icons';
import {
  StyledAdCard,
  StyledAdHeader,
  StyledAdLink,
  StyledAdSubHeader,
  StyledAdTextContent,
  StyledBrandImage,
  StyledCtaButton,
  StyledEhoLogo,
  StyledHeaderOverlay,
  StyledLogo,
} from './StyledComponents';
import { urlUtils } from '@zg-rentals/rental-manager-env';

export interface DfpPreviewInFeedProps {
  templateValues: Record<string, string>;
}

export const DfpPreviewInFeed = ({ templateValues }: DfpPreviewInFeedProps) => (
  <div className="DfpPreviewInFeed">
    <div id={`logo${templateValues.ListDisplayLogo}`}>
      <div className="container">
        <StyledAdCard>
          <StyledAdLink
            href={templateValues.DestinationUrl ? urlUtils.addProtocol(templateValues.DestinationUrl) : '#'}
            target="_blank"
            rel="noopener noreferrer"
            id="clickthru"
          >
            <StyledBrandImage style={{ backgroundImage: `url(${templateValues.ImageBrandRectangle})` }}>
              {templateValues.ListFlagOptions && (
                <StyledHeaderOverlay position="left">{templateValues.ListFlagOptions}</StyledHeaderOverlay>
              )}
              <StyledHeaderOverlay position="right">Sponsored</StyledHeaderOverlay>
              {templateValues.ListDisplayEHOImage === 'yes' && <StyledEhoLogo />}
            </StyledBrandImage>
            <StyledAdTextContent>
              <StyledAdHeader>{templateValues.TextHeader}</StyledAdHeader>
              <StyledAdSubHeader>{templateValues.TextSubheader01}</StyledAdSubHeader>
              <StyledAdSubHeader>{templateValues.TextSubheader02}</StyledAdSubHeader>
              <StyledCtaButton asChild>
                <a>
                  {templateValues.TextCTA}
                  <Icon css={{ marginLeft: 'xs' }}>
                    <IconExternalFilled />
                  </Icon>
                </a>
              </StyledCtaButton>
              {templateValues.ImageLogo && (
                <StyledLogo>
                  <img id="logoSrc" src={templateValues.ImageLogo} alt="" />
                </StyledLogo>
              )}
            </StyledAdTextContent>
          </StyledAdLink>
        </StyledAdCard>
      </div>
    </div>
  </div>
);

export default DfpPreviewInFeed;
